module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/pg-9ebf0bb36bfe656e7aba15d47451a236.svg";